function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
import qs from 'qs';
import config from '../config.json';
//  tried to use the getUser from '../components/common/classes/permissions', but this
//  triggers loading of createHashHistory which causes a 'Invariant Violation: Hash history needs
//  a DOM' error when running tests

// Safe to ignore: paths.getUser() is only called at runtime, not during module initialization
import { getUser } from '../utils/paths'; // eslint-disable-line import/no-cycle
// import logger from '../utils/logger';

import store from '../reducers/storeRegistration';
export const getAuthorizationHeader = () => {
  const user = getUser();

  // axios.defaults.headers.common.authorization = `Bearer ${tokenData.access_token}`;
  return {
    Authorization: `Bearer ${user.access_token}`
  };
};
export const getBaseURL = () => config.dataURL;
export const getAIBaseURL = () => config.aiURL;
export const getURL = (urlSuffix, customer = store.getState().login.customer) => {
  const url = config.dataURL + customer + urlSuffix;
  return url;
};
export { getErrorMessage, parseErrorEnvelope } from '../utils/errorEnvelope';
export const get = (url, params, responseType = 'json') => axios({
  method: 'GET',
  url: getURL(url),
  params,
  // Have to use repeating syntax for arrays because of problems with empty and single item
  // arrays: https://github.com/ljharb/qs/issues/315. Ideally, we'd use `arrayFormat: 'comma'` to
  // avoid repeating the variable name
  paramsSerializer: {
    serialize: p => qs.stringify(p)
  },
  responseType,
  headers: _objectSpread({}, getAuthorizationHeader())
});
export const getError = e => {
  // first check to see if the error is in axios format
  if (e && e.response) {
    let error = e.response.data;
    if (typeof error === 'string') {
      // bad certificate "0 Error" comes in as raw string. Tried to catch the OPTIONS request in
      // numerous ways, but since this is at the browser level there's not much control. The
      // string works in webkit and firefox.
      error = {
        error_msg: error
      };
    }
    if (error != null && typeof error !== 'object') {
      // API may return a primitive (e.g. 0, false, number); avoid assigning to it in strict mode
      error = {
        error_msg: String(error)
      };
    }
    if (!error) {
      error = {
        error_msg: e.response.statusText
      };
    }
    if (!error.error_msg) {
      // Prefer server-provided detail (e.g. SSO/OAuth uses "error", others use "error_msg")
      const detail = typeof error.error === 'string' ? error.error : null;
      return _objectSpread(_objectSpread({}, error), {}, {
        error_msg: detail || `${e.response.status} ${e.response.statusText}`
      });
    }
    // always return as much of the response.data as possible
    return error;
  }
  // if the error has a message, it's a basic error type so just pass the message out
  return {
    error_msg: e.message || e
  };
};
export const getFromProvidedURL = url => axios.get(url);
export const patch = (url, data, transformURI = true) => axios({
  url: transformURI ? getURL(url) : url,
  method: 'PATCH',
  data,
  headers: _objectSpread(_objectSpread({}, getAuthorizationHeader()), {}, {
    'Content-Type': 'application/json; charset=UTF-8'
  })
});
export const post = (url, data, transformURI = true, options = {}) => axios({
  url: transformURI ? getURL(url) : url,
  method: 'POST',
  data,
  headers: _objectSpread(_objectSpread({}, getAuthorizationHeader()), {}, {
    'Content-Type': 'application/json; charset=UTF-8'
  }, options.oneLastSave ? {
    'X-One-Last-Save': 'true'
  } : {})
});

/**
 *  Same as POST, but avoid OPTIONS request by using a different Content-Type.
 *  This is required for actions (i.e., login and token requests) that may
 *  need redirection to a proxy for checking client headers.
 */
export const postNoPreflight = (url, data, transformURI = true) => axios({
  method: 'POST',
  url: transformURI ? getURL(url) : url,
  withCredentials: true,
  data
});
export const put = (url, data, contentType = 'application/json; charset=UTF-8', responseType = 'json', transformURI = true, setHeaders = true, processData = true) => {
  const options = {
    url: transformURI ? getURL(url) : url,
    method: 'PUT',
    data,
    contentType,
    processData,
    responseType,
    headers: {
      'Content-Type': contentType
    }
  };

  // don't want to define headers for S3 requests
  if (setHeaders) {
    options.headers = _objectSpread(_objectSpread({}, options.headers), getAuthorizationHeader());
  }
  return axios(options);
};
export const remove = (url, params, data) => axios({
  url: getURL(url),
  method: 'DELETE',
  responseType: 'json',
  data,
  params,
  headers: _objectSpread(_objectSpread({}, getAuthorizationHeader()), {}, {
    'Content-Type': 'application/json; charset=UTF-8'
  })
});